module.exports = __webpack_public_path__ + "fonts/avenir_heavy.f080b689.ttf";